import React from 'react';
import './Dashboard.css';

function Equipment() {
    return (
        <div className="dashboard-container">
            <header className="dashboard-header card">
                <div className="welcome-text">
                    <h1>Equipment Management</h1>
                    <p>Manage laboratory equipment and inventory</p>
                </div>
            </header>

            {/* <div className="info-sections">
                <section className="info-card card">
                    <div className="info-header">
                        <h3>Equipment</h3>
                    </div>
                    <div className="info-content-grid">
                        <p>Equipment management interface will be implemented here.</p>
                    </div>
                </section>
            </div> */}
        </div>
    );
}

export default Equipment;
